import { Service } from "@turizi/shared";
import TransferTitle from "./titles/transfer-title";
import StayTitle from "./titles/stay-title";
import TourTitle from "./titles/tour-title";
import TransferTemplate from "@/types/templates/transfer-template";
import StayTemplate from "@/types/templates/stay-template";
import TourTemplate from "@/types/templates/tour-template";
import { getAttrValue } from "@/lib/models-utils";
import i18n from 'i18next';
import DefaultTitle from "./titles/default-title";

interface Props {
    service: Service;
    hideProviders?: boolean;
    hideCity?: boolean;
    links?: boolean;
}

export function ServiceTitle({
    service,
    // hideProviders,
    hideCity = false,
    links = false,
}: Props): JSX.Element {

    if (!service) return null;

    let title = null;
    if (service.category === TransferTemplate.category) {
        title = <TransferTitle service={service} links={links} />
    } else if (service.category === StayTemplate.category) {
        title = <StayTitle service={service} hideProviders={false} hideCity={hideCity} links={links} />
    } else if (service.category === TourTemplate.category) {
        title = <TourTitle service={service} hideCity={hideCity} links={links} />
    } else {
        title = <DefaultTitle service={service} links={links} />
    }
    return title;
}

export function ServiceTitleStatic(service?: Service | null): string {
    if (!service) return '';

    // only used in stay (Hotel, etc)
    const firstProviderName = service.providers?.[0]?.name;

    switch (service.category) {

        case TransferTemplate.category:
            const origin_city = getAttrValue(service, 'origin_city') || '?';
            const origin_zone = getAttrValue(service, 'origin_zone') || '';
            const destination_city = getAttrValue(service, 'destination_city') || '?';
            const destination_zone = getAttrValue(service, 'destination_zone') || '';
            const vehicle_type = i18n.t(getAttrValue(service, 'vehicle_type'));
            const regular = getAttrValue(service, 'regular_schedule') ? i18n.t('regular_schedule') : i18n.t('private');
            const round_trip = getAttrValue(service, 'round_trip') ? i18n.t('round_trip') : '';
            const arrow = round_trip ? '⇄' : '→';
            const trasnferDesc = [
                regular,
                round_trip,
                vehicle_type,
                service.name,
            ];
            return `${origin_city} ${origin_zone} ${arrow} ${destination_city} ${destination_zone} (${trasnferDesc.filter(Boolean).join(' · ').trim()})`

        case TourTemplate.category:
            const tourDesc = [
                getAttrValue(service, 'regular_schedule') ? i18n.t('regular_schedule') : i18n.t('private'),
                getAttrValue(service, 'vehicle_type'),
            ];
            return `${service.name || ''} (${tourDesc.filter(Boolean).join(' · ').trim()})`

        case StayTemplate.category:
            const home_type = getAttrValue(service, 'home_type') || '';
            const room_type = getAttrValue(service, 'room_type') || '';
            const category = getAttrValue(service, 'category') || '';
            const bedrooms_number = getAttrValue(service, 'bedrooms_number') || '';
            const capacity = getAttrValue(service, 'capacity') || '';
            const regime = getAttrValue(service, 'regime') || null;
            const special_view = getAttrValue(service, 'special_view') || null;
            const placeDesc = [
                home_type,
                room_type,
                category,
                special_view && special_view,
                regime && regime,
                bedrooms_number && `${bedrooms_number} ${Number(bedrooms_number) > 1 ? i18n.t('bedrooms') : i18n.t('bedroom')}`,
                capacity && `${capacity} ${i18n.t('paxs')}`,
            ];
            return `${firstProviderName ? `${firstProviderName}: ` : ''}${placeDesc.filter(Boolean).join(' · ')}`.trim()

        default:
            return service?.name?.trim() || '--';
    }
}